import script from "./JpVerificationCode.vue?vue&type=script&setup=true&lang=ts"
export * from "./JpVerificationCode.vue?vue&type=script&setup=true&lang=ts"

import "./JpVerificationCode.vue?vue&type=style&index=0&id=871ad7a2&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-871ad7a2"]])

export default __exports__